import { BaseOrganizationEndpoints } from "./base";
import {
  TessaChatListsResponse,
  TessaChatMessagesResponse
} from "../types/api-types";

export class Tessa extends BaseOrganizationEndpoints {
  async getUserChatList() {
    return this.requestWithStatus<TessaChatListsResponse>(
      "GET",
      "/v1/tessa/chats"
    );
  }

  async getChatMessages(chatId: string) {
    return this.requestWithStatus<TessaChatMessagesResponse>(
      "GET",
      `/v1/tessa/chats/${chatId}/messages`
    );
  }

  async setMessageState(chatId: string, messageId: string, state: any) {
    return this.requestWithStatus<TessaChatMessagesResponse>(
      "PUT",
      `/v1/tessa/chats/${chatId}/messages/${messageId}/state`,
      { state }
    );
  }
}
